import { Component, OnInit } from "@angular/core";
@Component({
  selector: "app-catalogo-view",
  templateUrl: "./catalogo-view.component.html",
  styleUrls: ["./catalogo-view.component.css"],
})
export class CatalogoViewComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { document.getElementsByClassName("head")[0].scrollIntoView(); }
}
